<template>
  <div class="w-full">
    <span
      v-if="replaceBookmarks(item?.firstLinkCompanionContent?.value)?.length ?? 0 > 0"
      class="text-racq-dark-grey text-m pr-1"
      v-html="replaceBookmarks(item?.firstLinkCompanionContent?.value)"
    ></span>
    <span>
      <a
        v-if="showRenewalDocumentLink()"
        @click="downloadDocument(insurancePolicy?.renewalDocumentId)"
        class="text-base inline cursor-pointer mb-2"
        v-html="replaceBookmarks(item.firstLinkContent.value)"
      ></a>
    </span>
    <div v-if="showRenewButton()" class="pt-3">
      <button class="!min-w-24 btn btn-sm btn-primary" data-test-id="actionButton" @click="renew_Click">
        {{ props.renewLink?.link?.value?.text }}
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { InsurancePolicy } from '@/interfaces';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { formatDate } from 'date-fns';
import { IInsurancePolicyStatusRules } from '@/utils/self-service-rules/InsurancePolicyStatusRules';
import { SelfServiceService } from '@/services/store';
import { Discriminators } from '@/constants/insurance-policy-const';

enum Bookmarks {
  renewalStartDate = 'renewalStartDate',
}

const props = defineProps<{
  insurancePolicy: InsurancePolicy;
  item: any;
  renewLink: any;
  policyStatusRules: IInsurancePolicyStatusRules;
}>();

const replaceBookmarks = (content: string) => {
  const renewalStartDate = props.insurancePolicy.renewalTermStart
    ? formatDate(props.insurancePolicy.renewalTermStart, 'dd MMMM yyyy').toString()
    : null;

  if (renewalStartDate) {
    content = replaceBookmark(Bookmarks.renewalStartDate, content, renewalStartDate);
  }

  //If no document replace this content.
  if (!props.insurancePolicy?.renewalDocumentId) {
    content = content.replace('View your', '');
  }

  return content;
};

const downloadDocument = async (documentId: string) => {
  if (!documentId) return;

  try {
    await SelfServiceService.getDownloadCoC(documentId);
  } catch (error) {
    console.error('error', error);
  }
};

const showRenewButton = () => {
  return props.policyStatusRules?.showPaymentDue && props.policyStatusRules?.autoRenewActuallyOff;
};

const showRenewalDocumentLink = () => {
  return (
    props.insurancePolicy?.renewalDocumentId !== undefined &&
    props.insurancePolicy?.currentTermPaymentDetails?.discriminator === Discriminators.NonResponsivePaymentDetails &&
    props.policyStatusRules?.autoRenewActuallyOff &&
    props.insurancePolicy?.currentRenewalPreference == false
  );
};

const renew_Click = () => {
  const url = props.renewLink.link.value.href + '?policyId=' + props.insurancePolicy.policyNumber;
  window.open(url, '_blank');
};
</script>
